import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';

import Documents from '../../components/Documents';
import { selectAuthenticatedUser } from '../../store/selectors/auth'
import { fetchFaqsNotesDocuments, saveFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectDocuments } from '../../store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from '../../store/actions/search';
import { upload } from '../../helpers/uploadDocument';
import moment from 'moment';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';
import { startFormLoading } from '../../store/actions/loader';
import {sortDocumentsList} from "../../helpers/CommonHelpers"

class ItemDocuments extends Component {
  componentDidMount() {
    const { item, onFetchFaqsNotesDocumentss,clearSearch } = this.props;
    onFetchFaqsNotesDocumentss(item.id);
    clearSearch()
  }
  onSave = async(document) => {
    this.props.onStartFormLoading();
    let image=null
    if(document && document.image && document.image.length === 1 && document.image[0].path){
      let path = document.image[0].path;
      let newFileName = path.split(/\.(?=[^\.]+$)/)[0] + moment().format('MMDDYYYYhmmss') + '.' + path.split(/\.(?=[^\.]+$)/)[1]
      image =  await upload(document.image[0], newFileName.replace(/ /g,''))
      document = document = {...document,image}
    }
    const { uploadType, ...documentData } = document;
    let data = {
      ItemId: this.props.item.id,
      Name: 'DOCUMENTS',
      Type: 'DOCUMENTS',
      Data: JSON.stringify(documentData).toString(),
      UserId: this.props.user.id,
      isImportantDocument: document.isImportantDocument
    }
    this.props.onSaveFaqsNotesDocuments(data)

  }
  onDeleteFaqsNotesDocuments(document){
    document.Type = 'DOCUMENTS';
    this.props.onDeleteFaqsNotesDocuments(document)
  }
  render() {
    const { documents, item,setSearch, loader } = this.props;

    // Modified By: Anjali
    // Modified On: 22-11-2023
    // Jira-Id: https://bosframework.atlassian.net/browse/JUN-3930
    // Reason: Items in the manuals & documents section need to be sorted alphabetically across all areas of Juniper (suite level, individual item level) -only property changed in 3898
    
    const sortDocuments = sortDocumentsList(documents)
    
    return (
      loader ? <Loader /> :
      <Documents
        breadcrumb={item.name}
        documents={sortDocuments}
        onSaveDocument={ (document) => this.onSave(document)}
        onDeleteDocument={(document) => this.onDeleteFaqsNotesDocuments(document)}
        onSearch={e => setSearch({ documents: e.target.value.trim() })}
        labelName={"Manuals & Documents"}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user:selectAuthenticatedUser(state),
  documents: selectDocuments(state),
  loader:selectPRLoader(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onSaveFaqsNotesDocuments:saveFaqsNotesDocuments,
  setSearch,
  clearSearch,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  onStartFormLoading: startFormLoading
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ItemDocuments);
